import { useT } from '../../hooks/useT';
import styles from './SectionTitle.module.css';

function SectionTitleBlock({ textKey, align = 'center', level = 'h2' }) {
  const t = useT();
  const Tag = level;

  return (
    <div className={styles.wrapper} style={{ textAlign: align }}>
      <Tag className={styles.title}>{t(textKey)}</Tag>
      <div
        className={styles.underline}
        style={{ margin: align === 'center' ? '0.75rem auto 0' : '0.75rem 0 0 0' }}
      />
    </div>
  );
}

export default SectionTitleBlock;
